import { useState,useRef } from "react";
import { useLocation } from "react-router-dom";

export default function RecurrentPaymentMITJson() {
  const { pathname } = useLocation();
  const [activeTab, setActiveTab] = useState(1);
  const [activeTabSecond, setActiveTabSecond] = useState(3);
  const [activeTabThird, setActiveTabThird] = useState(5);  
  const [activeTabFourth, setActiveTabFourth] = useState(7);
  const [activeTabFifth, setActiveTabFifth] = useState(9);    
  const [copied, setCopied] = useState(false);
  const copyBodyRef = useRef(null);
  const copyBodyRef1 = useRef(null);
  const copyBodyRef2 = useRef(null);
  const copyBodyRef3 = useRef(null);
  const copyBodyRef4 = useRef(null);
  
  const handleCopy = (ref) => {
    const text = ref.current.innerText;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); 
    });
  };
  return (
    <>
      <div className="doc-content">
        <h3 className="text-left pb-24 doc-title">Recurrent Payment MIT <span>(Merchant Initiated Transaction)</span></h3>
        <p className="text-in mb-24 black">Recurrent payment allows client to save payment method and use it automatically to pay transactions. In first Create Order – amount can be set to zero.</p>
        <h4 className="pb-16 sub-title flex-items-center">
          <span className="xml-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21.477"
              height="25.499"
              viewBox="0 0 21.477 25.499"
            >
              <g
                id="Type_Code_-_JSON_Style_Default"
                data-name="Type= Code - JSON, Style=Default"
                transform="translate(-1)"
              >
                <path
                  id="Path_6089"
                  data-name="Path 6089"
                  d="M23.516,5.448V22.723a2.026,2.026,0,0,1-2.026,2.026H7.776A2.026,2.026,0,0,1,5.75,22.723V2.776A2.026,2.026,0,0,1,7.776.75H18.4Z"
                  transform="translate(-1.789)"
                  fill="none"
                  stroke="#d0d5dd"
                  stroke-width="1.5"
                />
                <path
                  id="Path_6090"
                  data-name="Path 6090"
                  d="M24.623,1h0Zm5.3,5.922H25.247A1.247,1.247,0,0,1,24,5.675h5.922Zm-4.675,0A1.247,1.247,0,0,1,24,5.675V1h1.247V6.922ZM29.922,1V1Z"
                  transform="translate(-8.663 -0.094)"
                  fill="#d0d5dd"
                />
                <rect
                  id="Rectangle_2269"
                  data-name="Rectangle 2269"
                  width="19.947"
                  height="8.104"
                  rx="2"
                  transform="translate(1 12.75)"
                  fill="#2d3282"
                />
                <path
                  id="Path_6091"
                  data-name="Path 6091"
                  d="M6.57,22.942v2.98a1.4,1.4,0,0,1-.393,1.066,1.442,1.442,0,0,1-1.047.374,1.554,1.554,0,0,1-1.11-.393A1.457,1.457,0,0,1,3.6,25.853h1.06a.667.667,0,0,0,.112.418.4.4,0,0,0,.324.137.371.371,0,0,0,.3-.125.544.544,0,0,0,.106-.362v-2.98Zm2.444,4.42a2.251,2.251,0,0,1-.86-.156,1.424,1.424,0,0,1-.611-.461,1.273,1.273,0,0,1-.237-.736H8.441a.563.563,0,0,0,.168.374.55.55,0,0,0,.374.125.6.6,0,0,0,.374-.106.374.374,0,0,0,.137-.305.353.353,0,0,0-.112-.268.831.831,0,0,0-.268-.175,4.045,4.045,0,0,0-.449-.156,4.923,4.923,0,0,1-.692-.262,1.279,1.279,0,0,1-.461-.386,1.077,1.077,0,0,1-.193-.667,1.138,1.138,0,0,1,.443-.954,1.808,1.808,0,0,1,1.153-.349,1.828,1.828,0,0,1,1.166.349,1.229,1.229,0,0,1,.474.96H9.4a.44.44,0,0,0-.156-.33.54.54,0,0,0-.368-.125.45.45,0,0,0-.312.106.362.362,0,0,0-.118.293.367.367,0,0,0,.2.33,3.272,3.272,0,0,0,.623.256,5.547,5.547,0,0,1,.686.274,1.3,1.3,0,0,1,.461.38,1.018,1.018,0,0,1,.193.642,1.245,1.245,0,0,1-.193.679,1.309,1.309,0,0,1-.549.486A1.889,1.889,0,0,1,9.014,27.362Zm4.321,0a2.3,2.3,0,0,1-1.135-.287,2.18,2.18,0,0,1-.817-.8,2.274,2.274,0,0,1-.3-1.159,2.24,2.24,0,0,1,.3-1.153,2.18,2.18,0,0,1,.817-.8,2.3,2.3,0,0,1,1.135-.287,2.266,2.266,0,0,1,1.128.287,2.078,2.078,0,0,1,.81.8,2.24,2.24,0,0,1,.3,1.153,2.274,2.274,0,0,1-.3,1.159,2.134,2.134,0,0,1-.81.8A2.266,2.266,0,0,1,13.336,27.362Zm0-.972a1.064,1.064,0,0,0,.835-.349,1.317,1.317,0,0,0,.318-.923,1.3,1.3,0,0,0-.318-.923,1.064,1.064,0,0,0-.835-.349,1.1,1.1,0,0,0-.848.343,1.328,1.328,0,0,0-.312.929,1.342,1.342,0,0,0,.312.929A1.1,1.1,0,0,0,13.336,26.39Zm6.746.929H19.015l-1.783-2.7v2.7H16.167V22.942h1.066l1.783,2.712V22.942h1.066Z"
                  transform="translate(-0.98 -8.335)"
                  fill="#fff"
                />
              </g>
            </svg>
          </span>
          <span className="pl-12"> JSON</span>
        </h4>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">First Create Order.</p>         
        </div>

        
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Example of the request url:</p>
          <a
            href="https://libertypaytxtest.lb.ge:6444/order?terminalid=41
"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
           https://libertypaytxtest.lb.ge:6444/order?terminalid=41
          </a>
        </div>

        <div className="sub-link flex-items-center pb-32">
          <p className="black pr-8">Example of Authorization Header:</p>
          <strong>Authorization: Basic VGVybWluYWxTeXMvSUEwMDAxMDE6MTIzaW9wSU9QIw==</strong>
        </div>


        {/* Step 1: */}
        <h5 className="step-title">Step 1:</h5>
        <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTab === 1 ? "active-tab" : "tab"}
                onClick={() => setActiveTab(1)}
              >
                Request
              </div>
              <div
                className={activeTab === 2 ? "active-tab" : "tab"}
                onClick={() => setActiveTab(2)}
              >
                Response
              </div>
            </div>
             <button
              className={`btn btn-copy ${copied ? "copied" : ""}`}
              onClick={() => handleCopy(copyBodyRef)}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
               >
                <g
                  id="Organization-/-File-/-copy--file"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    fill="#FFFFFF"
                    opacity="0"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                    id="Fill"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
              <span className="pl-6"> {copied ? "Copied" : "Copy"} </span>
            </button>
          </div>

          <div className="tab-content">
            {activeTab === 1 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                    <pre
                      ref={copyBodyRef}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"order"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"typeRid"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"TWPG-Purchase"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"language"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"ka"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"amount"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"0"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"currency"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"GEL"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"description"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"test order"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"hppCofCapturePurposes"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'['}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        {/* <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"Cit"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span> */}
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"Recurring"</span>
                           <span className="token plain"></span>
                          <br />
                        </span>
                        {/* <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"UnspecifiedMit"</span>
                          <span className="token plain"></span>
                          <br />
                        </span> */}
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{']'}</span>
                          <span className="token punctuation">{','}</span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"custAttrs"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'['}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token ">"rid"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"@TWPG@CardHolderLogin","valAsStr": "Login121212"</span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token ">"rid"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Custom-needregcard","valAsStr":"on"</span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token ">"rid"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"@TWPG@ApproveURL","valAsStr":"https://libertypay.ge/Shop/out.jsp"</span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token ">"rid"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"@TWPG@DeclineURL","valAsStr":"https://libertypay.ge/Shop/out.jsp"</span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token ">"rid"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"@TWPG@CancelURL","valAsStr":"https://libertypay.ge/Shop/out.jsp"</span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{']'}</span>
                          <span className="token punctuation">{','}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"consumerDevice"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"browser"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"deviceId"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"6996B7A6-24D9-4F5A-BE09-99AD420AAFFF"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"acceptHeader"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"application/json,application/jose;charset=utf-8"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"ip"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"127.0.0.1"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"tzOffset"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"-300"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"platform"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"mozilla"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"jsEnabled"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">true</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"colorDepth"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">32</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"screenW"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">1024</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"screenH"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">800</span>
                          <span className="token punctuation">{','}</span>
                         <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"userAgent"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"chrome"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"language"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Ru-ru"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"javaEnabled"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">true</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">      </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">  </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                      </code>
                    </pre>    
                  </div>
                </div>
               </>
            ) : (
              <>
              <div className="code-ceontent">
                  <div className="code-body">
                 
                    <pre
                      ref={copyBodyRef}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"order"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"id"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"1939"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"status"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Preparing"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"password"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"1ekphcnoq2sm5"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                      </code>
                    </pre>
                   
                  </div>
                </div>
              </>
            )}{" "}
          </div>
          <div className="other-hint" style={{paddingTop:'0'}}>
            <p className="pb-12">Redirect client to TWPGA payment page to make first payment.</p>
            <a className="link underline" href="https://libertypaytxtest.lb.ge/twpga?id=1939&password=1ekphcnoq2sm5">
            https://libertypaytxtest.lb.ge/twpga?id=1939&password=1ekphcnoq2sm5
            </a>
            <p className="pt-12">After client finishes payment we need to Get Order Details. Use Id and password from previous response.</p>
          </div>
        </div>

        {/* Step 2: */}

        <h5 className="step-title">Step 2:</h5>

        <div className="sub-link  pb-32" style={{flexDirection:'column',alignItems : 'start'}}>
          <p className="black">Example of the request header:</p>
          <a
            href="https://libertypaytxtest.lb.ge:6444/order/1939?merchantId=41&password=1ekphcnoq2sm5&orderDe
            tailLevel=2&merchantDetailLevel=2&ctsDetailLevel=2&cofpDetailLevel=2&consumerDetailLevel=2&consum
            erTokenDetailLevel=2&tokenDetailLevel=2&tranDetailLevel=2&actionDetailLevel=2
            "
            target="_blank"
            className="link fnt-14 underline "
            style={{paddingLeft:'0'}}
          >
            https://libertypaytxtest.lb.ge:6444/order/1939?merchantId=41&password=1ekphcnoq2sm5&orderDe
            tailLevel=2&merchantDetailLevel=2&ctsDetailLevel=2&cofpDetailLevel=2&consumerDetailLevel=2&consum
            erTokenDetailLevel=2&tokenDetailLevel=2&tranDetailLevel=2&actionDetailLevel=2
         </a>
        </div>
        <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTabSecond === 3 ? "active-tab" : "tab"}
                onClick={() => setActiveTabSecond(3)}
              >
                Response body
              </div>
              {/* <div
                className={activeTabSecond === 4 ? "active-tab" : "tab"}
                onClick={() => setActiveTabSecond(4)}
              >
                Response
              </div> */}
            </div>
             <button
              className={`btn btn-copy ${copied ? "copied" : ""}`}
              onClick={() => handleCopy(copyBodyRef1)}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
               >
                <g
                  id="Organization-/-File-/-copy--file"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    fill="#FFFFFF"
                    opacity="0"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                    id="Fill"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
              <span className="pl-6"> {copied ? "Copied" : "Copy"} </span>
            </button>
          </div>

          <div className="tab-content">
            {activeTabSecond === 3 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                    <pre
                      ref={copyBodyRef1}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">…………………</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"storedTokens"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'['}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"id"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">1365</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{']'}</span>
                          <span className="token punctuation">{','}</span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token head">…………………</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                       
                        
                      </code>
                    </pre>    
                  </div>
                </div>
               </>
            ) : (
              <>
              </>
            )}{" "}
          </div>
          <div className="other-hint" style={{paddingTop:'0'}}>
            <p className="pb-12">From here we need only storedToken ID.</p>
            <p className="pt-12">Next Step is to make another Create Order, this time without forcing client to enter payment data.</p>
          </div>
        </div>


        {/* Step 3: */}
        <h5 className="step-title">Step 3:</h5>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Example of the request header:</p>
          <a
            href="https://libertypaytxtest.lb.ge:6444/order?terminalid=41

"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
            https://libertypaytxtest.lb.ge:6444/order?terminalid=41

          </a>
        </div>
        <div className="sub-link flex-items-center pb-32">
          <p className="black pr-8">Example of Authorization Header:: </p>
          <strong>Authorization: Basic VGVybWluYWxTeXMvSUEwMDAxMDE6MTIzaW9wSU9QIw==</strong>
        </div>
        <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTabThird === 5 ? "active-tab" : "tab"}
                onClick={() => setActiveTabThird (5)}
              >
                Request
              </div>
              <div
                className={activeTabThird  === 6 ? "active-tab" : "tab"}
                onClick={() => setActiveTabThird (6)}
              >
                Response
              </div>
            </div>
             <button
              className={`btn btn-copy ${copied ? "copied" : ""}`}
              onClick={() => handleCopy(copyBodyRef2)}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
               >
                <g
                  id="Organization-/-File-/-copy--file"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    fill="#FFFFFF"
                    opacity="0"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                    id="Fill"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
              <span className="pl-6"> {copied ? "Copied" : "Copy"} </span>
            </button>
          </div>

          <div className="tab-content">
            {activeTabThird === 5 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                    <pre
                      ref={copyBodyRef2}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"order"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"typeRid"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"MIT"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"language"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"ka"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"amount"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"0.1"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"currency"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"GEL"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"description"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"test order"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"hppCofCapturePurposes"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'['}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        {/* <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"Cit"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span> */}
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"Recurring"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        {/* <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"UnspecifiedMit"</span>
                          <span className="token plain"></span>
                          <br />
                        </span> */}
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{']'}</span>
                          <span className="token punctuation">{','}</span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"custAttrs"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'['}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token ">"rid"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"@TWPG@CardHolderLogin","valAsStr": "Login121212"</span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token ">"rid"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Custom-needregcard","valAsStr":"on"</span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token ">"rid"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"@TWPG@ApproveURL","valAsStr":"https://libertypay.ge/Shop/out.jsp"</span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token ">"rid"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"@TWPG@DeclineURL","valAsStr":"https://libertypay.ge/Shop/out.jsp"</span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token ">"rid"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"@TWPG@CancelURL","valAsStr":"https://libertypay.ge/Shop/out.jsp"</span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{']'}</span>
                          <span className="token punctuation">{','}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"consumerDevice"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"browser"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"deviceId"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"6996B7A6-24D9-4F5A-BE09-99AD420AAFFF"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"acceptHeader"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"application/json,application/jose;charset=utf-8"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"ip"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"127.0.0.1"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"tzOffset"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"-300"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"platform"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"mozilla"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"jsEnabled"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">true</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"colorDepth"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">32</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"screenW"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">1024</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"screenH"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">800</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"userAgent"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"chrome"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"language"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Ru-ru"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"javaEnabled"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">true</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">      </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">  </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                      </code>
                    </pre>    
                  </div>
                </div>
               </>
            ) : (
              <>
              <div className="code-ceontent">
                  <div className="code-body">                
                    <pre
                      ref={copyBodyRef2}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"order"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"id"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"1941"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"status"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Preparing"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"password"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"1rh0yo4se89rn"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                      </code>
                    </pre>
                   
                  </div>
                </div>
              </>
            )}{" "}
            <div className="other-hint" style={{paddingTop:'0'}}>
              <p className="pb-12">Now we need to set Source Token for that order</p>
            </div>
          </div>
          
        </div>



        {/* Step 4: */}
        <h5 className="step-title">Step 4:</h5>
        <div className="sub-link flex-items-center pb-32">
          <p className="black">Example of the request header:</p>
          <a
            href="https://libertypaytxtest.lb.ge:6444/order/1941/set-src-token?password=1rh0yo4se89rn"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
           https://libertypaytxtest.lb.ge:6444/order/1941/set-src-token?password=1rh0yo4se89rn

          </a>
        </div>
        
        <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTabFourth === 7 ? "active-tab" : "tab"}
                onClick={() => setActiveTabFourth (7)}
              >
                Request
              </div>
              <div
                className={activeTabFourth  === 8 ? "active-tab" : "tab"}
                onClick={() => setActiveTabFourth (8)}
              >
                Response
              </div>
            </div>
             <button
              className={`btn btn-copy ${copied ? "copied" : ""}`}
              onClick={() => handleCopy(copyBodyRef3)}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
               >
                <g
                  id="Organization-/-File-/-copy--file"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    fill="#FFFFFF"
                    opacity="0"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                    id="Fill"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
              <span className="pl-6"> {copied ? "Copied" : "Copy"} </span>
            </button>
          </div>

          <div className="tab-content">
            {activeTabFourth === 7 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                    <pre
                      ref={copyBodyRef3}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"order"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"initiationEnvKind"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Server"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>

                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token punctuation">{','}</span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"token"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"storedId"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"1365"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>             
                      </code>
                    </pre>    
                  </div>
                </div>
               </>
            ) : (
              <>
              <div className="code-ceontent">
                  <div className="code-body">                
                    <pre
                      ref={copyBodyRef3}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"order"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"status"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Preparing"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"cvv2AuthStatus"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"NotRequired"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"tdsV1AuthStatus"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"IneligibleOrder"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"tdsV2AuthStatus"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"IneligibleOrder"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"otpAutStatus"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"IneligibleOrder"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"srcToken"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"id"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"1367"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"paymentMethod"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Card"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"role"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Src"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"status"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Active"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"regTime"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"2023-03-17 16:09:02"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"displayName"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"412571******9128"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"card"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"expiration"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"0326"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"brand"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Visa"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"currency"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"GEL"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                      </code>
                    </pre>
                   
                  </div>
                </div>
              </>
            )}{" "}
            <div className="other-hint" style={{paddingTop:'0'}}>
              <p className="pb-12">Now we need to set Source Token for that order</p>
            </div>
          </div> 
        </div>

        
        {/* Step 5: */}
        <h5 className="step-title">Step 5:</h5>
         <div className="sub-link flex-items-center pb-12">
          <p> Last step is to execute our new transaction.</p>
         </div>
        <div className="sub-link flex-items-center pb-32">
          <p className="black">Example of the request header:</p>
          <a
            href="https://libertypaytxtest.lb.ge:6444/order/1941/exec-tran?password=1rh0yo4se89rn"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
          https://libertypaytxtest.lb.ge:6444/order/1941/exec-tran?password=1rh0yo4se89rn</a>
        </div>
        
        <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTabFifth === 9 ? "active-tab" : "tab"}
                onClick={() => setActiveTabFifth (9)}
              >
                Request
              </div>
              <div
                className={activeTabFifth  === 10 ? "active-tab" : "tab"}
                onClick={() => setActiveTabFifth (10)}
              >
                Response
              </div>
            </div>
             <button
              className={`btn btn-copy ${copied ? "copied" : ""}`}
              onClick={() => handleCopy(copyBodyRef4)}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
               >
                <g
                  id="Organization-/-File-/-copy--file"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    fill="#FFFFFF"
                    opacity="0"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                    id="Fill"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
              <span className="pl-6"> {copied ? "Copied" : "Copy"} </span>
            </button>
          </div>

          <div className="tab-content">
            {activeTabFifth === 9 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                    <pre
                      ref={copyBodyRef4}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"tran"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"phase"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Single"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"amount"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"0.1"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"conditions"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"cofUsage"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Recurring"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                      </code>
                    </pre>    
                  </div>
                </div>
               </>
            ) : (
              <>
              <div className="code-ceontent">
                  <div className="code-body">                
                     <pre
                      ref={copyBodyRef4}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"tran"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"approvalCode"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"378493"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"match"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"tranActionId"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"230317-11093925-000gh8="</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"ridByPmo"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"322608998"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                      </code>
                    </pre> 
                  </div>
                </div>
              </>
            )}{" "}
            <div className="other-hint" style={{paddingTop:'0'}}>
              <p className="pb-12">In case of order decline merchant may get such type of error:</p>
              <p className="pb-12 link">{JSON.stringify({errorCode: "PmoDecline",
                errorDescription: "Transaction declined by PMO: Auth Response: 6 - WITHOUT PIN EXCLUDECOUNT LIMIT(F)"
              }, null, 2)}</p>
              <p  className="pb-12">P.S. In case of zero amount status of transaction always will remain as “Preparing”, instead of “FullyPaid”.</p>
            </div>
          </div> 
        </div>
      </div>
    </>
  );
}
